// "Fixed" topics
import {SET_TOPICS} from './action';
import {getOfficialTopics} from '../services/topics';

const setTopics=(topics)=>{
  return {
    type: SET_TOPICS,
    topics
  }
}

const startGetOfficialTopics=(checkUpdate=false)=>{
  return async dispatch =>{
    try {
      const topics = await getOfficialTopics(checkUpdate);
      dispatch(setTopics(topics));
    } catch(e) {
      console.log('ERROR IN startGetOfficialTopics',e);
    }
  }
}


export {
  startGetOfficialTopics
}